import React, { useState, useEffect } from "react";
import { FaAngleUp } from "react-icons/fa";

const BackToTop: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [scrollProgress, setScrollProgress] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const scrolled = window.scrollY;
      setIsVisible(scrolled > 390);

      const scrollHeight =
        document.documentElement.scrollHeight - window.innerHeight;
      setScrollProgress(scrollHeight > 0 ? scrolled / scrollHeight : 0);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div
      style={{
        position: "fixed",
        bottom: 7,
        right: 3,
        display: isVisible ? "block" : "none",
        cursor: "pointer",
        zIndex: 9999, //which help for us layered concept
      }}
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      aria-label="Scroll to top"
    >
      <svg width={28} height={28} viewBox="0 0 28 28">
        <defs>
          <radialGradient id="myGradient" cx="100%" cy="0%" r="100%">
            <stop offset="0%" stopColor="#4a9d6f" />
            <stop offset="100%" stopColor="#4a9d6f" />
          </radialGradient>
        </defs>
        <circle
          cx="14"
          cy="14"
          r="12"
          fill="url(#myGradient)"
          style={{ transition: "fill 0.2s ease-in-out" }}
        />
      </svg>

      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: 28,
          height: 28,
          display: scrollProgress > 0 ? "flex" : "none",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          transition: "visibility 0.2s linear",
        }}
      >
        <FaAngleUp style={{ fontSize: "0.8rem", color: "#FFFFFF", marginBottom: -7 }} />
        <FaAngleUp style={{ fontSize: "0.8rem", color: "#FFFFFF" }} />
      </div>
    </div>
  );
};

export default BackToTop;
